



































import { defineComponent } from "@vue/composition-api";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";

/**
 * バージョン切り替え警告モーダル
 */
export default defineComponent({
  components: {
    OccModal,
    OccButton,
    OccHeading
  },
  props: {
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  name: "VersionSwitchAlertModal"
});
